export default (modul, value) => {
  const session = JSON.parse(localStorage.getItem('user'));
  if (!session) {
    window.location.href = '/auth/login';
    return false;
  }

  const targetModul = (modul || '').trim().toUpperCase();
  const hakAksesList = session.hak_akses || [];

  // Cari konfigurasi hak akses modul ini
  const found = hakAksesList.find(
    (row) => row.modul && row.modul.trim().toUpperCase() === targetModul
  );

  // Jika modul sudah terkonfigurasi di hak_akses:
  if (found !== undefined && found !== null) {
    const jenisAkses = parseInt(found.jenis_akses, 10);
    // Explicit 0: MUTLAK DIBLOKIR / TIDAK ADA AKSES untuk SEMUA user (termasuk user lama & admin)
    if (jenisAkses === 0) {
      return false;
    }
    return jenisAkses >= value;
  }

  // Fallback untuk modul yang belum ada di hak_akses database:
  // 1. Dashboard selalu boleh diakses oleh semua user yang sudah login
  if (targetModul === 'DASHBOARD') {
    return true;
  }

  // 2. Jika user memiliki Master User >= 3, izinkan modul baru yang belum tercatat di hak_akses
  const hasMasterUserAdmin = hakAksesList.some(
    (a) =>
      a.modul &&
      a.modul.trim().toUpperCase() === 'MASTER USER' &&
      parseInt(a.jenis_akses, 10) >= 3
  );

  if (hasMasterUserAdmin) {
    return true;
  }

  // User biasa tanpa konfigurasi hak_akses untuk modul ini tidak diizinkan
  return false;
};
